import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg, SearchBar, matchZoek, datumNL } from '../components/PortalLayout';

export default function Onderhoud() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [zoek, setZoek] = useState('');
  useEffect(() => {
    api.get('/klantportaal/onderhoud')
      .then((r) => setItems(r.data.onderhoud || []))
      .catch(() => setError('Kon onderhoudsplanning niet laden'));
  }, []);
  const zichtbaar = (items || []).filter((o) => matchZoek(zoek, o.klant_naam, o.object_naam, o.frequentie, o.ordernummer, o.dienst_type));
  return (
    <PortalLayout titel="Onderhoudsplanning">
      {items && items.length > 0 && (
        <SearchBar value={zoek} onChange={setZoek} placeholder="Zoek op wissel, order of frequentie..." />
      )}
      <StateMsg loading={!items && !error} error={error} leeg={items && items.length === 0} leegTekst="Geen geplande onderhoudsbeurten." />
      {items && items.length > 0 && (
        <div style={{ color: '#94a3b8', fontSize: 12, marginBottom: 10 }}>{zichtbaar.length} van {items.length}</div>
      )}
      {zichtbaar.map((o) => (
        <div key={o.id} style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
            <div style={{ fontWeight: 600, color: '#1e293b' }}>{o.klant_naam || o.object_naam || 'Onderhoud'}</div>
            <span style={{ background: '#ecfdf5', color: '#047857', fontSize: 12, fontWeight: 600, padding: '3px 8px', borderRadius: 6, whiteSpace: 'nowrap' }}>{datumNL(o.volgende_datum)}</span>
          </div>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>
            {[o.frequentie, o.ordernummer ? 'order ' + o.ordernummer : null, o.dienst_type].filter(Boolean).join(' \u00b7 ')}
          </div>
          {o.notities && <div style={{ color: '#475569', fontSize: 13, marginTop: 6, whiteSpace: 'pre-wrap' }}>{o.notities}</div>}
        </div>
      ))}
    </PortalLayout>
  );
}
